import React, { useState } from "react"
import QRCode from "qrcode.react"
import { Container, Input, Form, FormGroup } from "reactstrap"

const Generator = () => {
  const [link, setLink] = useState("")

  const generateQR = (e) => {
    e.preventDefault()
    console.log(`link is == ${link}`)
  }

  return (
    <div>
      <Container className="qr-padding">
        <Form onSubmit={generateQR}>
          <FormGroup>
            <Input
              placeholder="Enter site link"
              required
              type="textarea"
              value={link}
              onChange={(e) => setLink(e.target.value)}
            />
          </FormGroup>

          <Input
            type="submit"
            value="Generate QR"
            className="btn btn-primary"
          />
        </Form>
        <QRCode
          bgColor="#0000"
          fgColor="#055df5"
          size={350}
          value={link}
          className="qr-padding"
          renderAs="canvas"
          level="L"
          includeMargin={true}
        />
      </Container>
    </div>
  )
}

export default Generator
